import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import AdminLayout from './layouts/AdminLayout';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import UserDetail from './pages/UserDetail';
import UsageDashboard from './pages/UsageDashboard';
import Orders from './pages/Orders';
import Settings from './pages/Settings';
import Providers from './pages/Providers';
import Affiliates from './pages/Affiliates';
import SystemSettings from './pages/SystemSettings';
import PaymentSettings from './pages/PaymentSettings';
import ReferralCampaigns from './pages/ReferralCampaigns';
import Feedbacks from './pages/Feedbacks';
import CustomerServiceConfig from './pages/CustomerServiceConfig';
import APIKeys from './pages/APIKeys';
import SystemMaintenance from './pages/SystemMaintenance';
import Plugins from './pages/Plugins';
import Presets from './pages/Presets';
import Batches from './pages/Batches';
import RateLimits from './pages/RateLimits';
import RouteRouter from './pages/RouteRouter';
import OpenRouterModels from './pages/OpenRouterModels';
import XRToken from './pages/XRToken';
import Cosmos from './pages/Cosmos';
import Qd from './pages/Qd';
import W3Models from './pages/W3Models';
import Wan3Models from './pages/Wan3Models';
import Qiwise from './pages/Qiwise';
import ProviderHealthMonitor from './pages/ProviderHealthMonitor';
import ProviderWhitelist from './pages/ProviderWhitelist';
import PaymentReturn from './pages/PaymentReturn';
import SmsConfig from './pages/SmsConfig';

function App() {
  const token = localStorage.getItem('admin_token');

  return (
    <Routes>
      <Route
        path="/login"
        element={token ? <Navigate to="/" /> : <Login />}
      />
      {/* 支付返回页面 - 公开访问，不需要登录 */}
      <Route path="/payment-return" element={<PaymentReturn />} />
      {/* 供应商审批管理 - 独立访问，不需要登录（通过自身管理密码验证） */}
      <Route path="/operator-auth" element={<ProviderWhitelist />} />
      <Route
        path="/"
        element={token ? <AdminLayout /> : <Navigate to="/login" />}
      >
        <Route index element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="users/:id" element={<UserDetail />} />
        <Route path="usage-dashboard" element={<UsageDashboard />} />
        <Route path="orders" element={<Orders />} />
        <Route path="api-keys" element={<APIKeys />} />
        <Route path="providers" element={<Providers />} />
        <Route path="affiliates" element={<Affiliates />} />
        <Route path="referral-campaigns" element={<ReferralCampaigns />} />
        <Route path="feedbacks" element={<Feedbacks />} />
        <Route path="system-settings" element={<SystemSettings />} />
        <Route path="payment-settings" element={<PaymentSettings />} />
        <Route path="customer-service-config" element={<CustomerServiceConfig />} />
        <Route path="settings" element={<Settings />} />
        <Route path="system-maintenance" element={<SystemMaintenance />} />
        <Route path="plugins" element={<Plugins />} />
        <Route path="presets" element={<Presets />} />
        <Route path="batches" element={<Batches />} />
        <Route path="rate-limits" element={<RateLimits />} />
        <Route path="sms-config" element={<SmsConfig />} />
        <Route path="route-router" element={<RouteRouter />} />
        <Route path="openrouter-models" element={<OpenRouterModels />} />
        <Route path="xrtoken" element={<XRToken />} />
        <Route path="cos" element={<Cosmos />} />
        <Route path="qd" element={<Qd />} />
        <Route path="w3-models" element={<W3Models />} />
        <Route path="wan3-models" element={<Wan3Models />} />
        <Route path="qiwise" element={<Qiwise />} />
        <Route path="provider-health" element={<ProviderHealthMonitor />} />
      </Route>
    </Routes>
  );
}

export default App;
